module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.5 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell-box.html"
    }
  }, [_vm._v("CellBox")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add prop:align-items")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix missing icon style when using checklist along #2041")]), _vm._v(" "), _c('li', [_vm._v("[fix] initializing the tempValue when created #2059")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] fix click events trigger twice when clicking fast #2048")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add event:on-hde event:on-show #2053")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] fix validating logic for is-type:china-mobile with mask #2040")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37a21d7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-37a21d7c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.5-127.vue
// module id = 2149
// module chunks = 255